module.exports = function() {
  return new Worker(__webpack_public_path__ + "136a45fb85f3607a7bfb.worker.js");
};